
<a *ngIf="button.content" class="btn_cta {{ button.content.template.class }}" [target]="(button.content['targetBlank']) ? 'target=\'_blank\'' : ''" href="{{ button.content['link'] }}">
<span>{{ button.content['title'] }}</span>
</a>
